import { Api } from '@axiom/ui';
import type { User } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class UserApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readUser() {
    return super.read<{ data: User }>({
      endpoint: `/user/me/contactAccountInfo`,
      method: 'GET',
    });
  }

  async refreshUser() {
    return super.invalidate(`/user/me/contactAccountInfo`);
  }
}

export const UserApi = new UserApiClass();
